//
//
//
//
//
//
//
//
//
export default {
  name: 'BianlidianManage',
  data: function data() {
    return {
      isRouterAlive: true
    };
  },
  created: function created() {
    console.log('created BianlidianManage');
  },
  activated: function activated() {
    var _this = this;

    console.log('activated BianlidianManage');
    this.isRouterAlive = false;
    this.$nextTick(function () {
      return _this.isRouterAlive = true;
    });
  }
};